import type { UserRole } from '../context/AuthContext';

export type { UserRole };

export interface Usuario {
  id: string;
  /** CUIT/CUIL de la persona (11 dígitos). Identificador de login. */
  cuit: string | null;
  /** Correo de contacto (para recuperar clave). No es la identidad de login. */
  email: string;
  nombre: string;
  apellido: string | null;
  rol: UserRole;
  empresa_id: string | null;
  activo: boolean;
  created_at: string;
  empresa?: {
    id: string;
    razon_social: string;
    cuit: string;
  } | null;
}

export interface UsuarioCreatePayload {
  /** CUIT/CUIL de la persona (11 dígitos, sin guiones). Identificador de login. */
  cuit: string;
  email: string;
  password: string;
  nombre: string;
  apellido?: string | null;
  rol: UserRole;
  empresa_id?: string | null;
}

export interface UsuarioUpdatePayload {
  nombre?: string;
  apellido?: string | null;
  rol?: UserRole;
  empresa_id?: string | null;
}

/** Etiqueta legible del rol (duplica la de menuConfig para evitar dependencia circular) */
export function getRolLabel(rol: UserRole): string {
  switch (rol) {
    case 'admin_general': return 'Admin General';
    case 'operador':      return 'Operador';
    case 'admin_empresa': return 'Admin Empresa';
    default:              return rol;
  }
}
